import React from "react";
import styles from "./GoogleDrive.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

const CHECK_ITEMS = [
	"Browse your Google Drive files",
	"Select documents to print",
	"Open supported file types",
	"Print files directly",
];

function CheckIcon() {
	return (
		<span className={cx("check")} aria-hidden="true">
			<svg
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
				strokeWidth="2.5"
			>
				<path d="M20 6L9 17l-5-5" />
			</svg>
		</span>
	);
}

function GoogleDrive() {
	return (
		<section className={cx("googleDrive")} id="google-drive">
			<div className={cx("card")}>
				<h2 className={cx("title")} id="drive-title">
					Why does this app request Google Drive access?
				</h2>
				<p className={cx("intro")}>
					Printer: Smart Print Documents requests Google Drive access
					only after you choose to import files from your Google Drive
					account.
				</p>
				<p className={cx("label")}>The permission is used only to:</p>
				<ul className={cx("checklist")}>
					{CHECK_ITEMS.map((item) => (
						<li className={cx("item")} key={item}>
							<CheckIcon />
							{item}
						</li>
					))}
				</ul>
				<p className={cx("note")}>
					The application never uploads, modifies, or shares your
					Google Drive files with third parties.
				</p>
			</div>
		</section>
	);
}

export default GoogleDrive;
